import { Component } from '@angular/core';
import { CredentialType } from 'enums/CredentialType';
import { Layout } from 'modules/layout';
import { CredentialRequired } from 'services/credential.service';
import { ListContactComponent } from 'components/company/contact/list-contact.component';
import { CompanyInformationComponent } from 'components/company/company-information.component';
import { EditLegalCaseComponent } from './edit-legal-case.component';
import { ViewLegalCasesComponent } from './view-legal-cases.component';
import { TranslatePipe } from 'pipes/translate.pipe';
import { CompanyDataProviderFactory } from 'services/company-data-provider';

@CredentialRequired(CredentialType.EditLegalCases)
@Component({
	templateUrl: './create-legal-case.component.html',
	providers: [CompanyDataProviderFactory],
	imports: [Layout, EditLegalCaseComponent, ListContactComponent, CompanyInformationComponent, TranslatePipe]
})
export class CreateLegalCaseComponent extends ViewLegalCasesComponent {
}
